import styled from 'styled-components';
import { Select } from 'antd';

const EbzSelect = styled(Select)`
  .ant-select-selector {
    background-color: #dedede !important;
  }
`;

export default EbzSelect;
